import { PropsWithChildren, ReactNode, CSSProperties } from 'react';
import { RadioGroup } from '@headlessui/react';
import { Card } from './Card';
import cn from 'classnames';
import { twMerge } from 'tailwind-merge';

export type RadioCardComponentProps<T = string> = PropsWithChildren<{
  value: T | undefined;
  disabled?: boolean;
  title?: ReactNode;
  subtitle?: ReactNode;
  footer?: ReactNode;
  icon?: ReactNode;
  className?: string;
  contentStyles?: CSSProperties;
  customHeader?: ReactNode;
}>;

function RadioCardComponent<T = any>({
  className,
  value,
  disabled,
  ...props
}: RadioCardComponentProps<T>) {
  return (
    <RadioGroup.Option value={value} disabled={disabled} data-testid={`radio-option-${value}`}>
      {({ active, checked }) => (
        <>
          <Card
            className={twMerge(
              cn(
                'shadow',
                {
                  'cursor-not-allowed': disabled,
                  'outline outline-2 outline-primary-600': checked,
                  'ring-2 ring-primary-200': active && !disabled,
                  'cursor-pointer hover:border hover:border-primary-200': !checked && !disabled,
                },
                className,
              ),
            )}
            {...props}
          />
        </>
      )}
    </RadioGroup.Option>
  );
}

export type RadioCardGroupProps<T = string> = PropsWithChildren<{
  value?: T | undefined;
  onChange?: (value: T) => void;
  disabled?: boolean;
  name?: string;
  className?: string;
}>;

function RadioCardGroup<T = any>(props: RadioCardGroupProps<T>) {
  return <RadioGroup {...props} />;
}

export const RadioCard = Object.assign(RadioCardComponent, {
  Group: RadioCardGroup,
});
